import HeaderBar from "./HeaderBar";
import { useTheme } from "./ThemeContext";
import '../../styles/style.css';
import { JSXElementConstructor, Key, ReactElement, ReactNode, ReactPortal, useEffect, useState } from "react";
import axios from 'axios';
import { toast } from "react-toastify";
import { useData } from "./MemberData";
import Cookies from "js-cookie";

interface Questions{
    question: any;
    options: any;
    correct: Number;
}

interface Cooldowns {
  [key: string]: string;
}

function TestPage() {
  const { theme } = useTheme();
  const [testType, setTestType] = useState("");
  const [inTest, setInTest] = useState(false);
  const [resultPage, setResultPage] = useState(false);
  const [questions, setQuestions] = useState<Questions[]>([]);
  const [testFailed, setFailed] = useState("");
  const [remainingTime, setRemainingTime] = useState(0);
  const { membersData, getDiscordMemberInfo, refreshAccessToken } = useData();
  const [cooldowns, setCooldowns] = useState<Cooldowns>({});
  const [myDiscordID, setMyDiscordID] = useState('');

  const sendCooldownMessage = async () => {
    const today = new Date();
    const futureDate = new Date(today);

    if (testType === "radio" || testType === "bls") {
      futureDate.setDate(today.getDate() + 3);
    } else if (testType === "rezidentiat") {
      futureDate.setDate(today.getDate() + 5);
    }

    const formatter = new Intl.DateTimeFormat('ro-RO', {
      timeZone: 'Europe/Bucharest',
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });

    const formattedDate = formatter.format(futureDate);
    let token = Cookies.get("accessToken");
    try {
      await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
        callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
        cooldownTest: testType,
        cooldownDays: testType === "radio" ? 3 : testType === "bls" ? 3 : 5,
        hrDiscordID: myDiscordID,
        dateCooldown: `${formattedDate}`,
        message: true
      }, { headers: { Authorization: `Bearer ${token}` } });
    } catch (error) {
      if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
        const newAccessToken = await refreshAccessToken();
        if (newAccessToken) {
          await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
            callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
            cooldownTest: testType,
            cooldownDays: testType === "radio" ? 3 : testType === "bls" ? 3 : 5,
            hrDiscordID: myDiscordID,
            dateCooldown: `${formattedDate}`,
            message: true
          }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
        }
      }
    } 
  }

  useEffect(() => {
    const handleBeforeUnload = (event: { preventDefault: () => void; returnValue: string; }) => {
      if (inTest && (testFailed === "" || testFailed === "passed")) {
        event.preventDefault();
        event.returnValue = "";
        sendCooldownMessage();
      }
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [inTest, testFailed]);
  
  useEffect(() => {
    setMyDiscordID(Cookies.get('myDiscordID') || '');
    
    for (let index = 0; index < membersData.length; index++) {
      const element = membersData[index];
      if (element.discordID === Cookies.get('myDiscordID')) {
        if (typeof element.cooldowns === 'string') {
          setCooldowns(JSON.parse(element.cooldowns));
        }
      }
    }
  }, [membersData]);

  const startTest = async () => {
    setFailed("");
    if (testType !== "" && (testType === 'radio' || testType === 'bls' || testType === 'rezidentiat')) {
      if (cooldowns[testType] !== "-") {
        toast.error("Ai un cooldown activ pentru acest test!");
        return;
      } else {
        if (getDiscordMemberInfo(myDiscordID, "certificates")?.[testType] === true) {
          toast.error("Ai deja acest test promovat!");
          return;
        } else {
            if (testType === 'rezidentiat' && getDiscordMemberInfo(myDiscordID, "callsign") > 400) {
              toast.error("Nu ai acces la acest test!");
              return;
            }
            try {
              const token = Cookies.get("accessToken");
              const response = await axios.get(`http://panelmedici.fplayt.ro:5000/tests/get?testType=${testType}`, { headers: { Authorization: `Bearer ${token}` } });
              if (response && response.data) {
                setQuestions(response.data.questions);
                setRemainingTime(response.data.time);
                setInTest(true);
                toast.success("Testul a inceput! Succes!")
              }
            } catch (err) {
              toast.error("A aparut o eroare! Incearca mai tarziu.");
            }
          }
        }
    }
  }

  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedOption, setSelectedOption] = useState(null);
  const [mistakes, setMistakes] = useState(0);
  const [answeredQuestions, setAnsweredQuestions] = useState<number[]>([]);

  const handleSelect = (index: any) => {
    setSelectedOption(index);
  };

  const handleSubmit = async () => {
    if (selectedOption === null) return;
  
    if (selectedOption !== questions[currentIndex].correct) {
      if (mistakes === 2) {
        setFailed("mistakes");
        setResultPage(true);
        const today = new Date();
        const futureDate = new Date(today);
    
        if (testType === "radio" || testType === "bls") {
          futureDate.setDate(today.getDate() + 3);
        } else if (testType === "rezidentiat") {
          futureDate.setDate(today.getDate() + 5);
        }
        const formatter = new Intl.DateTimeFormat('ro-RO', {
          timeZone: 'Europe/Bucharest',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
        const [day, month] = formatter.format(futureDate).split('.');
        let token = Cookies.get("accessToken");
        try {
          await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
            callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
            cooldownTest: testType,
            cooldownDays: testType === "radio" ? 3 : testType === "bls" ? 3 : 5,
            hrDiscordID: myDiscordID,
            dateCooldown: `${day}.${month}`,
            message: true
          }, { headers: { Authorization: `Bearer ${token}` } });
        } catch (error) {
          if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
            const newAccessToken = await refreshAccessToken();
            if (newAccessToken) {
              await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
                callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                cooldownTest: testType,
                cooldownDays: testType === "radio" ? 3 : testType === "bls" ? 3 : 5,
                hrDiscordID: myDiscordID,
                dateCooldown: `${day}.${month}`,
                message: true
              }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
            }
          }
        }
        return;
      }
      setMistakes((prev) => prev + 1);
    }
  
    setAnsweredQuestions((prev) => [...prev, currentIndex]); 
    nextQuestion();
  };
  
  const handleLater = () => {
    const unansweredQuestions = questions.map((_, index) => index).filter(index => !answeredQuestions.includes(index));
  
    if (unansweredQuestions.length <= 1) {
      return; 
    }
  
    let nextIndex = currentIndex + 1;
    while (answeredQuestions.includes(nextIndex) && nextIndex < questions.length) {
      nextIndex++;
    }
  
    if (nextIndex >= questions.length) {
      nextIndex = unansweredQuestions[0];
    }
  
    setCurrentIndex(nextIndex);
    setSelectedOption(null);
  };
  
  const nextQuestion = async () => {
    const unansweredQuestions = questions.map((_, index) => index).filter(index => !answeredQuestions.includes(index));
  
    if (unansweredQuestions.length === 0) {
      setFailed("Passed");
      setResultPage(true);
      try {
        await axios.post("http://panelmedici.fplayt.ro:5000/api/test-passed", {
          testType: testType.toUpperCase(),
          discordID: myDiscordID
        }, { headers: { Authorization: `Bearer ${Cookies.get("accessToken")}` } });
      } catch (error) {
        if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
          const newAccessToken = await refreshAccessToken();
          if (newAccessToken) {
            await axios.post("http://panelmedici.fplayt.ro:5000/api/test-passed", {
              testType: testType.toUpperCase(),
              discordID: myDiscordID
            }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
          }
        }
      }
    }
  
    let nextIndex = currentIndex + 1;
  
    while (answeredQuestions.includes(nextIndex) && nextIndex < questions.length) {
      nextIndex++;
    }
  
    if (nextIndex >= questions.length) {
      nextIndex = unansweredQuestions[0]; 
    }
  
    setCurrentIndex(nextIndex);
    setSelectedOption(null);
  };
  
  useEffect(() => {
    const handleTestFailure = async () => {
      if (remainingTime <= 0 && inTest) {
        setFailed("timeExpired");
        setResultPage(true);
        const today = new Date();
        const futureDate = new Date(today);
  
        if (testType === "radio" || testType === "bls") {
          futureDate.setDate(today.getDate() + 3);
        } else if (testType === "rezidentiat") {
          futureDate.setDate(today.getDate() + 5);
        }
  
        const formatter = new Intl.DateTimeFormat('ro-RO', {
          timeZone: 'Europe/Bucharest',
          day: '2-digit',
          month: '2-digit',
          year: 'numeric'
        });
  
        const formattedDate = formatter.format(futureDate);
        let token = Cookies.get("accessToken");
        try {
          await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
            callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
            cooldownTest: testType,
            cooldownDays: testType === "radio" ? 3 : testType === "bls" ? 3 : 5,
            hrDiscordID: myDiscordID,
            dateCooldown: `${formattedDate}`,
            message: true
          }, { headers: { Authorization: `Bearer ${token}` } });
        } catch (error) {
          if (axios.isAxiosError(error) && error.response && error.response.status === 401) {
            const newAccessToken = await refreshAccessToken();
            if (newAccessToken) {
              await axios.post("http://panelmedici.fplayt.ro:5000/api/give-cooldown", {
                callsign: getDiscordMemberInfo(myDiscordID, "callsign"),
                cooldownTest: testType,
                cooldownDays: testType === "radio" ? 3 : testType === "bls" ? 3 : 5,
                hrDiscordID: myDiscordID,
                dateCooldown: `${formattedDate}`,
                message: true
              }, { headers: { Authorization: `Bearer ${newAccessToken}` } });
            }
          }
        }
      }
    };
  
    if (remainingTime <= 0 && inTest) {
      handleTestFailure();
      return;
    }
  
    if (inTest) {
      const interval = setInterval(() => {
        setRemainingTime((prevTime) => Math.max(prevTime - 1000, 0));
      }, 1000);
  
      return () => clearInterval(interval);
    }
  }, [remainingTime, inTest]);  

  const formatTime = (milliseconds: number) => {
    const minutes = Math.floor(milliseconds / 60000);
    const seconds = Math.floor((milliseconds % 60000) / 1000);
    return `${minutes}m ${seconds}s`;
  };

  const handleTestFinish = async () => {
    setResultPage(false);
    setInTest(false);
    window.location.reload();
  }

  function formatFields(data: any) {
    const labels = {
      radio: "RADIO",
      bls: "BLS",
      rezidentiat: "REZIDENTIAT",
      smuls: "SMULS",
      moto: "MOTO",
      pilot: "PILOT"
    };
    const result = Object.keys(data)
      .filter(key => data[key] !== "-")
      .map(key => labels[key as keyof typeof labels]);

    return result.length > 0 ? result.join(", ") : "";
  }

  return (
    <div className={`${theme} w-full h-full flex flex-col`}>
      <HeaderBar currentPage="Teste Departament" />
      <div className="w-[99%] h-[87%] box-border p-[1%] pt-[0.5%] bg-[rgba(255,255,255,0.61)] dark:bg-[#605D5D61] flex flex-col gap-[1%] backdrop-blur-[32px] rounded-[1vw]">
        <div className="w-full h-[7%] flex items-center justify-between">
          {inTest === true ? (
            <span className="textSemiBold text-black dark:text-white text-[1.1vw] w-full text-center">Testare {testType.toUpperCase()}</span>
          ) : (
            <span className="textSemiBold text-black dark:text-white text-[1.1vw] w-full text-center">Testare certificate RADIO, BLS, Rezidentiat</span>
          )}
        </div>
        {resultPage === false ? (
          (inTest === false ? (
            <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
              {cooldowns  && (
                <div className="w-full h-[12%] flex flex-row items-center justify-end border-box pr-[2%]">
                  <span className="bg-[#D9D9D960] h-[60%] px-[2%] rounded-[.5vw] textSemiBold text-black dark:text-white flex items-center justify-center">Cool Down-uri active : {formatFields(cooldowns)}</span>
                </div>
              )}
              <div className="w-full h-[70%] flex flex-col items-center box-border pt-[2%]">
                <span className="textExtraBold text-black dark:text-white text-[1.5vw]">Selectează testul pe care dorești să îl susții</span>
                <div className="mt-[6%] w-[50%] h-[20%] flex flex-row items-center justify-center gap-[2%]">
                  <div onClick={() => setTestType("radio")} className={`testButton ${testType === 'radio' && "bg-gradient-to-r from-[#D8630F] to-[#F59318]"}`}>
                    <span className="textBold text-black dark:text-white text-[1.1vw]">Radio</span>
                  </div>
                  <div onClick={() => setTestType("bls")} className={`testButton ${testType === 'bls' && "bg-gradient-to-r from-[#D8630F] to-[#F59318]"}`}>
                    <span className="textBold text-black dark:text-white text-[1.1vw]">BLS</span>
                  </div>
                </div>
                <div className="w-[50%] h-[20%] flex flex-row items-center justify-center gap-[2%]">
                  <div onClick={() => setTestType("rezidentiat")} className={`testButton ${testType === 'rezidentiat' && "bg-gradient-to-r from-[#D8630F] to-[#F59318]"}`}>
                    <span className="textBold text-black dark:text-white text-[1.1vw]">Rezidențiat</span>
                  </div>
                </div>
              </div>
              <div className="w-full h-[18%] flex flex-row items-center justify-center gap-[1%]">
                <div onClick={startTest} className="w-[17%] h-[45%] cursor-pointer hover:scale-105 bg-gradient-to-r from-[#D8630F] to-[#F59318] flex items-center justify-center rounded-[.5vw]">
                  <span className="textBold text-white text-[1.1vw]">ÎNCEPE TESTUL</span>
                </div>
              </div>
            </div>
          ) : (
            <div className="bg-white dark:bg-[#323232] w-full h-[93%] rounded-xl flex flex-col overflow-y-scroll">
              <div className="w-full h-[12%] flex flex-row items-center justify-center gap-[5%]">
                <span className="textSemiBold text-black dark:text-white text-[1.25vw]">
                  Întrebarea{" "}
                  <span className="textBold gradient-text">
                    {currentIndex + 1}/{questions.length}
                  </span>
                </span>
                <span className="textSemiBold text-black dark:text-white text-[1.25vw]">
                  Timp rămas <span className="textBold gradient-text">{formatTime(remainingTime)}</span>
                </span>
                <span className="textSemiBold text-black dark:text-white text-[1.25vw]">
                  Greseli <span className="textBold gradient-text">{mistakes}/3</span>
                </span>
              </div>
  
              <div className="w-full h-[12%] flex items-center justify-center">
                <span className="w-[75%] text-black dark:text-white textBold text-center text-[1.5vw] text-wrap">
                  {questions[currentIndex].question}
                </span>
              </div>
  
              <div className="options w-full h-[58%] flex flex-col items-center justify-center gap-[2%]">
                {questions[currentIndex].options.map((option: string | number | boolean | ReactElement<any, string | JSXElementConstructor<any>> | Iterable<ReactNode> | ReactPortal | null | undefined, index: Key | null | undefined) => (
                  <div
                    key={index}
                    className={`option cursor-pointer ${
                      selectedOption === index ? "selected" : ""
                    }`}
                    onClick={() => handleSelect(index)}
                  >
                    <div className={`ball ${selectedOption === index ? "active" : ""}`}></div>
                    <span className="text-black dark:text-white textSemiBold text-[1vw]">{option}</span>
                  </div>
                ))}
              </div>
  
              <div className="w-full h-[18%] flex items-center justify-center gap-[1%]">
                <div
                  className="w-[20%] h-[47%] flex items-center justify-center bg-gradient-to-r from-[#D8630F] to-[#F59318] rounded-[.5vw] cursor-pointer"
                  onClick={handleSubmit}
                >
                  <span className="textBold text-[1.2vw] text-white">
                    TRIMITE RĂSPUNSUL
                  </span>
                </div>
                <div
                  className={`w-[20%] h-[47%] flex items-center justify-center bg-transparent border-2 border-black dark:border-white rounded-[.5vw] cursor-pointer ${
                    answeredQuestions.length === questions.length - 1
                      ? "opacity-50 cursor-not-allowed"
                      : ""
                  }`}
                  onClick={handleLater}
                >
                  <span className="textBold text-[1.2vw] text-black dark:text-white">
                    RĂSPUND MAI TÂRZIU
                  </span>
                </div>
              </div>
            </div>
          ))
        ) : (
          (testFailed && (
            <div className="w-full h-full flex flex-col items-center justify-center gap-[2%]">
              <span className="textBold text-[2vw] text-black dark:text-white">{testFailed === "Passed" ? "Felicitări! Ai promovat testul!" : "Din păcate nu ai reușit să promovezi testul."}</span>
              <div onClick={handleTestFinish} className="cursor-pointer px-[3%] py-[.8%] rounded-[.5vw] bg-gradient-to-r from-[#D8630F] to-[#F59318]">
                <span className="textBold text-white text-[1.3vw]">PAGINA PRINCIPALĂ</span>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}

export default TestPage;